// Thin wrapper around the existing usePushNotifications hook
// for imperative use (e.g. from settings page buttons).
import { supabase } from './supabase';

const VAPID_PUBLIC = import.meta.env.VITE_VAPID_PUBLIC_KEY as string | undefined;

function urlBase64ToUint8Array(base64: string): Uint8Array {
  const padding = '='.repeat((4 - base64.length % 4) % 4);
  const b64     = (base64 + padding).replace(/-/g, '+').replace(/_/g, '/');
  const raw     = atob(b64);
  return new Uint8Array([...raw].map(c => c.charCodeAt(0)));
}

export async function subscribeToPush(): Promise<boolean> {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) return false;
  if (!VAPID_PUBLIC) return false;

  const permission = await Notification.requestPermission();
  if (permission !== 'granted') return false;

  const reg = await navigator.serviceWorker.register('/sw.js');
  const sub = await reg.pushManager.subscribe({
    userVisibleOnly:      true,
    applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC) as unknown as ArrayBuffer,
  });

  const { data: { user } } = await supabase.auth.getUser();
  if (!user) return false;

  const json = sub.toJSON();
  await supabase.from('push_subscriptions').upsert({
    user_id:  user.id,
    platform: 'web',
    endpoint: sub.endpoint,
    auth:     json.keys?.auth,
    p256dh:   json.keys?.p256dh,
    token:    sub.endpoint, // satisfies existing NOT NULL constraint
  }, { onConflict: 'user_id,endpoint' });

  return true;
}
